import { upgradeMotorApplyBusinessRules, upgradeMotorGetPolicy } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import {
  IServiceResponse,
  ApplyRulesRequestOfUpgradeCoverageUpdateModel,
  ApplyRulesResponseOfUpgradeCoverageViewModel,
  InsurancePolicy,
} from '@/interfaces';

export const UpgradeMotorService = {
  /**
   * Get Policy
   *
   * @param quoteSessionId
   */
  getPolicy(quoteSessionId: string): Promise<IServiceResponse<InsurancePolicy>> {
    return _http.HttpGet(upgradeMotorGetPolicy.replace('{0}', quoteSessionId));
  },

  /**
   * Apply Business Rules
   *
   * @param request
   */
  applyBusinessRules(
    request: ApplyRulesRequestOfUpgradeCoverageUpdateModel
  ): Promise<IServiceResponse<ApplyRulesResponseOfUpgradeCoverageViewModel>> {
    return _http.HttpPost(upgradeMotorApplyBusinessRules, request);
  },
};
